var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2821_1952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.5002H4C3.46957 14.5002 2.96086 14.2894 2.58579 13.9144C2.21071 13.5393 2 13.0306 2 12.5002V11.8335H5.66667",
    stroke: "#0061FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6.16667V3.83333C11.3333 3.56963 11.4115 3.31184 11.558 3.09257C11.7045 2.87331 11.9127 2.70241 12.1563 2.60149C12.4 2.50058 12.6681 2.47417 12.9267 2.52562C13.1853 2.57707 13.4229 2.70405 13.6094 2.89052C13.7959 3.07699 13.9229 3.31457 13.9743 3.57321C14.0257 3.83185 13.9993 4.09994 13.8984 4.34358C13.7975 4.58721 13.6266 4.79545 13.4073 4.94196C13.1881 5.08847 12.9303 5.16667 12.6666 5.16667H11.3333",
    stroke: "#0061FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 2.5H5.33325C4.80282 2.5 4.29411 2.71071 3.91904 3.08579C3.54397 3.46086 3.33325 3.96957 3.33325 4.5V11.8333",
    stroke: "#0061FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.1665H8.66667",
    stroke: "#0061FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.8335H8.66667",
    stroke: "#0061FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.28 8.90665C12.5426 8.64409 12.8987 8.49658 13.27 8.49658C13.6413 8.49658 13.9974 8.64409 14.26 8.90665C14.5226 9.16922 14.6701 9.52533 14.6701 9.89665C14.6701 10.268 14.5226 10.6241 14.26 10.8867L10 15.1667H8V13.1667L12.28 8.90665Z",
    stroke: "#0061FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2821_1952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.e9e3b2663192669462c38678bd031de0.svg";
export { ForwardRef as ReactComponent };